import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 20,
    fontSize: 10,
  },

  // Header styles
  header: {
    alignItems: "center",
    marginBottom: 10,
    position: "relative",
  },
  logo: {
    width: "100px",
    height: "auto",
    position: "absolute",
    top: "0px",
    left: "0px",
  },
  reportTitle: {
    fontSize: 16,
    color: "#000",
    marginBottom: 3,
  },
  reportPeriod: {
    fontSize: 14,
    color: "#000",
    marginBottom: 3,
  },
  entryCount: {
    fontSize: 14,
    color: "#000",
  },

  // Note entry styles
  noteEntry: {
    marginBottom: 5,
    border: "0.5px solid #171717",
  },

  noteHeader: {
    backgroundColor: "#1D2939",
    color: "#fff",
    padding: "8px 12px",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  clientInfo: {
    fontSize: 11,
    color: "#FAFAFA",
  },
  dateInfo: {
    fontSize: 14,
    color: "#FFF",
  },

  // Content sections
  contentSection: {
    padding: "8 12",
    borderBottom: "1px solid #000",
    backgroundColor: "#E2E8F0",
  },
  lastSection: {
    padding: "8 12",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },

  ShiftInfoContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
    marginRight: "15px",
  },
  // sectionRow: {
  //   flexDirection: "column",
  //   marginBottom: 8,
  // },
  sectionRow: {
    flexDirection: "row", // label + content in a row
    alignItems: "flex-start", // align to the top
    flexWrap: "wrap", // allow wrapping if needed
    marginBottom: 8,
  },

  sectionLabel: {
    width: 100,
    fontSize: 11,
    fontWeight: "800",
    color: "#101828",
    paddingRight: 8,
  },

  sectionContent: {
    flex: 1,
    fontSize: 11,
    lineHeight: 1.4,
    color: "#000000",
    flexWrap: "wrap",
    // backgroundColor: "#FCFCFD"
  },

  shiftInfo: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: "15px",
  },

  staffInfo: {
    flexDirection: "row",
    alignItems: "center",
  },

  staffAndShiftLabel: {
    fontSize: 11,
    fontWeight: "800",
    color: "#101828",
    paddingRight: 8,
  },

  staffName: {
    fontSize: 11,
    color: "#101828",
  },

  signature: {
    fontSize: 8,
    fontStyle: "italic",
    color: "#666",
    backgroundColor: "#E5E5E5",
    filter: "drop-shadow(0 1px 2px rgba(16, 24, 40, 0.05))",
    width: "100px",
    height: "40px",
    borderRadius: 8,
    marginLeft: "15px",
    justifyContent: "center",
    alignItems: "center",
  },

  // Outcome/Goal section
  outcomeSection: {
    backgroundColor: "#f8f9fa",
    // padding: "8 12",
    borderBottom: "1px solid #000",
  },

  outcomeRow: {
    flexDirection: "row",
    // marginBottom: 4,
  },

  outcomeLabel: {
    width: 140,
    padding: "8 12",
    fontSize: 11,
    fontWeight: "800",
    color: "#101828",
  },

  outcomeContent: {
    borderLeft: "1px solid #000",
    padding: "8 12",
    backgroundColor: "#E2E8F0",
    flex: 1,
    fontSize: 11,
    lineHeight: 1.4,
    color: "#000000",
    flexWrap: "wrap",
  },

  essentialActAndFreq:{
    fontSize: 10
  },

  coverPage: {
    position: "relative",
    flex: 1,
  },

  coverWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },

  coverBg: {
    width: "100%",
    height: "100%",
  },

  coverContent: {
    position: "absolute",
    bottom: 20,
    left: 20,
    right: 20,
  },

  coverFacility: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 8,
  },

  coverFacilityLabel: {
    fontSize: 16,
    color: "#DEDFE1",
    marginRight: "10px",
  },
  coverFacilityName: {
    fontSize: 16,
    color: "#000000",
  },
  signatureImage: {
    maxWidth: "95px",
    maxHeight: "35px",
  },
  signatureText: {
    fontSize: 12,
    color: "#171717",
  },
  multipleOptionsContainer: {
    paddingVertical: 4,
    paddingHorizontal: 8,
    marginRight: 6,
    marginBottom: 4,
    backgroundColor: "#F2F0F0",
    borderRadius: 2,
  },
  multipleOptionsText: {
    color: "#000000",
    fontSize: 11,
    fontWeight: 400,
  },
});
